import * as React from 'react';
import { TextLink, Typography } from '@drone-js/core';

var CalendarLabel = function CalendarLabel(props) {
  var onClick = props.onClick,
    label = props.label,
    _props$headingTag = props.headingTag,
    headingTag = _props$headingTag === void 0 ? 'h3' : _props$headingTag;
  return onClick ? /*#__PURE__*/React.createElement(TextLink, {
    hierarchy: "secondary",
    label: label,
    textVariant: "heading-default",
    trailingIcon: "fill.arrow.thick-dropdown",
    onClick: onClick
  }) : /*#__PURE__*/React.createElement(Typography, {
    tag: headingTag,
    variant: "heading-default"
  }, label);
};

export { CalendarLabel };
//# sourceMappingURL=CalendarLabel.js.map
